/**
 * Color palette for the Employee Transfers application
 * Based on Pizza Hut branding and design system
 */

// Primary colors
export const primary = {
  main: '#E31837', // Pizza Hut red
  light: '#FF4D5F',
  dark: '#B30015',
  contrastText: '#FFFFFF',
};

// Secondary colors
export const secondary = {
  main: '#333333', // Dark gray
  light: '#555555',
  dark: '#222222',
  contrastText: '#FFFFFF',
};

// Neutral colors
export const grey = {
  50: '#FAFAFA',
  100: '#F5F5F5',
  200: '#EEEEEE',
  300: '#E0E0E0',
  400: '#BDBDBD',
  500: '#9E9E9E',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
};

// Text colors
export const text = {
  primary: '#212121',
  secondary: '#757575',
  disabled: '#9E9E9E',
  link: '#266DCC', // Blue 700 for text links
};

// Background colors
export const background = {
  default: '#FFFFFF',
  paper: '#FFFFFF',
  light: '#F5F5F5',
};

// Status colors
export const status = {
  error: {
    main: '#D32F2F',
    light: '#EF5350',
    dark: '#C62828',
  },
  warning: {
    main: '#FFA000',
    light: '#FFB333',
    dark: '#CC8000',
  },
  info: {
    main: '#0288D1',
    light: '#03A9F4',
    dark: '#01579B',
  },
  success: {
    main: '#388E3C',
    light: '#4CAF50',
    dark: '#2E7D32',
  },
};

// Other UI colors
export const divider = '#E0E0E0';
export const overlay = 'rgba(0, 0, 0, 0.5)';
export const shadow = 'rgba(0, 0, 0, 0.1)';

// Export the full palette object for use with MUI theme
const palette = {
  primary,
  secondary,
  error: status.error,
  warning: status.warning,
  info: status.info,
  success: status.success,
  grey,
  text,
  background,
  divider,
  status, // Export status directly in the palette
};

export default palette;
